import React, { useState } from "react";

import ImagesGalleryDesktop from "./images-gallery-desktop";
import ImagesGalleryMobile from "./images-gallery-mobile";

const ImagesGallery = ({ data }) => {
  return (
    <>
      <ImagesGalleryDesktop data={data} />
      {/* <ImagesGalleryMobile data={data} /> */}
    </>
  );
};

export default ImagesGallery;
